import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import './Order.css';
import priceFormat from './../../utils/showPriceFormat';

const Order = (props) => {
    const { number, factureNumber, person, customer, insertDate, description } = props;
    const { price, cashBagAmount, orderType, discount, totalPrice, transferType} = props;

    const [showOrder, setShowOrder] = useState(false);
    return (
        <React.Fragment>

        <div className="order-layer">
            <header className="order-layer-header">
                <div className="d-flex justify-content-between align-items-center p-2">
                    <span className="order-number d-flex flex-wrap col-6 px-0" >
                        <div className="mr-1">
                            <span className="font-weight-bold text-muted border rounded-circle px-2">{number}</span>
                        </div>
                        <div>
                            <span className="gs">{factureNumber.split('-')[0]}</span>
                            <span className="">-</span>
                            <span className="">{factureNumber.split('-')[1]}</span>
                        </div>
                        <div className="col-12 ml-3">
                            <span className='small'>
                                {orderType === 'staff' ? 'درخواست متخصص' : 'فروش ضایعات'}
                            </span>
                        </div>
                    </span>
                    <span className="col-1 px-0">
                        <button
                            style={{ position: 'relative', top: '7px', left:'7px' }}
                            className="btn btn-success rounded-circle px-1 py-0"
                            onClick={() => setShowOrder(!showOrder)}
                        >
                            <i className={`fa fa-arrow-${showOrder ? 'up' : 'down'}`}></i>
                        </button>

                    </span>
                    <span className="order-date col-5 px-0 text-right">
                        <small>{insertDate.split(' ')[0]}</small>
                        <small>{insertDate.split(' ')[1]}</small>
                    </span>
                </div>
            </header>
            <Collapse
                id="contentcollapse"
                in={showOrder}
            >
                <div>
                    {
                        orderType === 'scrap' &&
                        <section className="scrap-section p-2">
                            <div>
                                <div className="order-facture">
                                    <h1>فاکتور</h1>
                                    <div className="d-flex flex-wrap justify-content-between mt-3">
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-5 col-xl-4 px-0 d-flex flex-column">
                                            <h6 className="font-weight-bold">اطلاعات مشتری</h6>
                                            <span className="font-weight-bold ">
                                                <span >نام و نام خانوادگی</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{customer.fullName}</span>
                                            </span>
                                            <span className="font-weight-bold ">
                                                <span >شماره موبایل</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{customer.mobileNumber}</span>
                                            </span>
                                            <span className="font-weight-bold ">
                                                <span >شماره ثابت</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{customer.telephone}</span>
                                            </span>
                                            <span className="font-weight-bold ">
                                                <span >آدرس</span>
                                                <span className="mx-1">:</span>
                                                <p className="text-muted">{customer.address}</p>
                                            </span>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-5 col-xl-4 px-0">
                                            <h6 className="font-weight-bold mt-3 mt-sm-0">اطلاعات پروژه</h6>
                                            <span className="font-weight-bold ">
                                                <span >توضیحات</span>
                                                <span className="mx-1">:</span>
                                                <p className="text-muted mb-1">{description}</p>
                                            </span>
                                            <div className="d-flex justify-content-between text-success">
                                                <span>پرداخت به مشتری</span>
                                                <span>
                                                    {priceFormat(String(price))}<span className="ml-1">تومان</span>
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between text-info mt-2">
                                                <span>نوع پرداخت</span>
                                                <span>
                                                    {transferType === 'cash' ? 'نقدی' : 'کیف پول'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    }
                    {
                        orderType === 'staff' &&
                        <section className="scrap-section p-2">
                            <div>
                                <div className="order-facture">
                                    <h1>فاکتور</h1>
                                    <div className="d-flex flex-wrap justify-content-between mt-3">
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-5 col-xl-4 px-0 d-flex flex-column">
                                            <h6 className="font-weight-bold">اطلاعات مشتری</h6>
                                            <span className="font-weight-bold ">
                                                <span >نام و نام خانوادگی</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{customer.fullName}</span>
                                            </span>
                                            <span className="font-weight-bold ">
                                                <span >شماره موبایل</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{customer.mobileNumber}</span>
                                            </span>
                                            <span className="font-weight-bold ">
                                                <span >شماره ثابت</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{customer.telephone}</span>
                                            </span>
                                            <span className="font-weight-bold ">
                                                <span >آدرس</span>
                                                <span className="mx-1">:</span>
                                                <p className="text-muted">{customer.address}</p>
                                            </span>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-5 col-xl-4 px-0 d-flex flex-column">
                                            <h6 className="font-weight-bold">اطلاعات متخصص</h6>
                                            <span className="font-weight-bold ">
                                                <span >نام و نام خانوادگی</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{person.fullName}</span>
                                            </span>
                                            {/* <span className="font-weight-bold ">
                                                <span >شماره موبایل</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{person.mobileNumber}</span>
                                            </span> */}
                                            <span className="font-weight-bold ">
                                                <span >کد متخصص</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{person.code}</span>
                                            </span>
                                            <span className="font-weight-bold ">
                                                <span >دسته شغلی</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{person.jobCategoryName}</span>
                                            </span>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-5 col-xl-4 px-0">
                                            <h6 className="font-weight-bold mt-3 mt-sm-0">اطلاعات پروژه</h6>
                                            <span className="font-weight-bold ">
                                                <span >توضیحات</span>
                                                <span className="mx-1">:</span>
                                                <p className="text-muted mb-1">{description}</p>
                                            </span>
                                            <div className="d-flex justify-content-between ">
                                                <span>مجموع هزینه</span>
                                                <span>
                                                    {priceFormat(String(totalPrice))}<span className="ml-1">تومان</span>
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between text-danger mt-2">
                                                <span>میزان تخفیف</span>
                                                <span>
                                                    {priceFormat(String(discount))}<span className="ml-1">تومان</span>
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between text-secondary mt-2">
                                                <span>برداشت از کیف پول</span>
                                                <span>
                                                    {priceFormat(String(cashBagAmount))}<span className="ml-1">تومان</span>
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between text-success mt-2">
                                                <span>مبلغ پرداختی</span>
                                                <span>
                                                    {priceFormat(String(price))}<span className="ml-1">تومان</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    }
                </div>

            </Collapse>
        </div>
        </React.Fragment>

    );
}

export default Order;